import NotistackWrapper from "./presentation/component/NotistackWrapper";
import Router from "./presentation/routes/Router";
import {
  createTheme,
  CssBaseline,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material";
import "@fontsource/ibm-plex-sans-arabic/300.css";
import "@fontsource/ibm-plex-sans-arabic/400.css";
import "@fontsource/ibm-plex-sans-arabic/500.css";
import "@fontsource/ibm-plex-sans-arabic/600.css";
import "@fontsource/ibm-plex-sans-arabic/700.css";
import { useEffect } from "react";
import { showGlobalLoadingView } from "./core/utils/Utils";
import { MAIN_FONT_FAMILY } from "./data/constant/Constants";

const theme = createTheme({
  typography: {
    fontFamily: MAIN_FONT_FAMILY,
  },
});

function App() {
  useEffect(() => {
    showGlobalLoadingView(false);
  }, []);
  return (
    <ThemeProvider theme={responsiveFontSizes(theme)}>
      <CssBaseline />
      <NotistackWrapper>
        <Router />
      </NotistackWrapper>
    </ThemeProvider>
  );
}

export default App;
